export default __webpack_public_path__ + "static/media/oscer-pres-nausea.56e71cbc.svg";